import React, { useContext } from 'react';
import { ThemeProvider } from '@mui/material/styles';
import { SoftDepthContext } from './SoftDepthScope';

export interface LegacyThemeScopeProps {
  children: React.ReactNode;
}

/**
 * Puts back the theme the enclosing SoftDepthScope replaced, for a legacy
 * component that has to render inside a scope — e.g. GeneralVoiceWithAiButton
 * in the smart filter, whose RecordDialog and LoadingBackdrop were built
 * against the app theme and would otherwise restyle (type sizes, button
 * colours) the moment a scope wraps them. It restores what was outside, not
 * the global theme by name, so a page with its own ThemeProvider keeps it.
 * Outside any scope it changes nothing.
 *
 * A Soft Depth control passed back into such a component re-enters with a bare
 * `<SoftDepthScope>`, which picks the outer scope's mode up through context.
 */
const LegacyThemeScope = ({ children }: LegacyThemeScopeProps) => {
  const scope = useContext(SoftDepthContext);
  if (!scope) return <>{children}</>;
  return <ThemeProvider theme={scope.outerTheme}>{children}</ThemeProvider>;
};

export default LegacyThemeScope;
